import queryString from 'query-string';
import React, { useState } from 'react';
import { Modal, Text, TouchableOpacity, View, Dimensions } from 'react-native';
import { getActions, getItemListClick } from '../../shared';
import { processStyles } from '../util.style';
import { checkFont } from '../func';
import QRCodeIcon from '../Icons/QRCodeIcon';
import BarcodeScannerConfig from './config';
import WebcamBarcodeScanner from '../../BarcodeScanner/WebcamBarcodeScanner';

const windowWidth = Dimensions.get('window').width;

const BarcodeScanner: React.FC<any> = (props) => {
  const search = queryString.parse(window?.location?.search);
  const localePreview = search?.locale;
  let { locale } = props;
  locale = locale || localePreview;

  const {
    changeInput,
    valueInputs,
    onPress,
    attributes,
    style,
    libraryComponentManifest,
    ...otherProps
  } = props;

  const [openScanner, setOpenScanner] = useState(false);

  const { finalStyle } = processStyles({
    attributes,
    style,
    config: BarcodeScannerConfig,
    libraryComponentManifest,
    ...otherProps,
  });

  const onPressModal = () => {
    setOpenScanner(true);
  };

  const handlePressAction = (result: string, id: string) => {
    onPress &&
      onPress(getActions(props, id), {
        itemListClick: getItemListClick(props.record),
        scannerCode: result,
      });
  };

  const containerStyle = {
    width: finalStyle.width,
    height: finalStyle.height,
    zIndex: finalStyle.zIndex,
    marginTop: finalStyle.marginTop,
    borderRadius: finalStyle.borderRadius,
    display: 'flex' as const,
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    backgroundColor: finalStyle.backgroundColor || '#0175FF',
    overflow: 'hidden' as const,
  };

  const textStyle = {
    color: finalStyle.color || '#FFFFFF',
    fontFamily: checkFont(finalStyle.fontFamily),
    fontSize: finalStyle.fontSize,
    fontWeight: finalStyle.fontWeight?.toString() || '700',
    marginLeft: 8,
  };

  return (
    <>
      <Modal visible={openScanner} onRequestClose={() => setOpenScanner(false)}>
        <View
          style={{ width: '100%', height: '100%', backgroundColor: 'black' }}
        >
          <View
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              flex: 1,
              top: 0,
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'center',
            }}
          >
            <View
              style={{
                width: 250,
                height: 130,
                borderLeftWidth: 5,
                borderRightWidth: 5,
                borderTopWidth: 5,
                borderBottomWidth: 5,
                borderTopColor: '#4259AC',
                borderLeftColor: '#4259AC',
                borderRightColor: '#4259AC',
                borderBottomColor: '#4259AC',
              }}
            ></View>
          </View>
          <TouchableOpacity
            onPress={() => setOpenScanner(false)}
            style={{
              width: 29,
              height: 29,
              backgroundColor: 'white',
              position: 'absolute',
              top: windowWidth / 10,
              right: 23,
              zIndex: 99,
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 23,
            }}
          >
            <Text>X</Text>
          </TouchableOpacity>
          <WebcamBarcodeScanner
            onError={() => {
              setOpenScanner(false);
            }}
            onDetected={(value: string) => {
              setOpenScanner(false);
              changeInput(value);
              handlePressAction(value, 'onPress');
            }}
          />
        </View>
      </Modal>
      {!valueInputs ? (
        openScanner ? null : (
          <TouchableOpacity style={containerStyle} onPress={onPressModal}>
            <QRCodeIcon color={finalStyle.color} />
            <Text style={textStyle}>
              {locale === 'ja' ? 'コードを読み取る' : 'Click to scan'}
            </Text>
          </TouchableOpacity>
        )
      ) : openScanner ? null : (
        <TouchableOpacity style={containerStyle} onPress={onPressModal}>
          <Text style={textStyle}> {valueInputs} </Text>
        </TouchableOpacity>
      )}
    </>
  );
};

export default React.memo(BarcodeScanner);
